module.exports = __webpack_public_path__ + "img/HauntedHouse-cover.8ac68fde.png";